module.exports = __webpack_public_path__ + "img/sieckFinesseAdaptation13.9440c94c.png";